<template>
<div id="login">
  <div id="login_img"><img src="./img/login.jpg" /></div>
  <div id="login_main">
    <div id="login_main_top">
      <h1>深圳市正睿沣科技有限公司</h1>
      <!-- <a>用户名linmm,密码都是000000 </a> -->
    </div><!-- main头部结尾-->
    <div id="login_main_center">
      <!-- :rules="rules2" ref="loginForm" label-width="25%" class="demo-ruleForm"-->
      <el-form :model="loginForm" :rules="rules2" ref="loginForm" class="demo-ruleForm">
        <el-form-item prop="account">
          <el-input type="text" v-model="loginForm.account" placeholder="用户名" auto-complete="off" />
        </el-form-item>
        <el-form-item prop="pwd">
          <el-input type="password" v-model="loginForm.pwd" placeholder="密码"  auto-complete="off" />
        </el-form-item>
        <el-form-item>
          <div id="login_button_user">
            <el-button type="primary" @click="doLogin" :loading="loading">登录</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div><!-- main中部结尾-->
  </div><!-- main结尾-->
  <div id="login_footer">
    Copyright © 2019-2020 深圳市正睿沣科技有限公司  备案号：<a href="http://www.beian.miit.gov.cn/" target="_blank">粤ICP备20069653号-2</a>
  </div>
</div><!-- login结尾-->
</template>

<script>
  import Cookies from 'js-cookie'
  import store from '@/store'

export default {
  data() {

    var validateAccount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'));
      }
      callback();
    };
    var validatePwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      }
      callback();
    };
    return {
      loginForm: {
        account: '',
        pwd: ''
      },
      // 表单验证规则
      rules2: {
        account: [{
          validator: validateAccount,
          trigger: 'blur'
        }],
        pwd: [{
          validator: validatePwd,
          trigger: 'blur'
        }]
      },
      loading: false,

      dialog_regs: false
    };
  },
  methods: {
    //错误封装方法
    errormsg(msgerror) {
      this.$message.error(msgerror)
    },
    //登录加载过渡效果的方法
    load() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    doLogin() {
      var _this = this;
      this.$http.post('/api/user/login', {
          account: _this.loginForm.account,
          pwd: _this.loginForm.pwd
        })
        .then(function(response) {
          var resultCode = response.data.code;
          if (resultCode === "200") {
            //进去主界面的过渡效果方法
            _this.load();

            // _this.$store.commit('setCacheUser', {data:response.data.result.user})
            //放置token到Cookie
            Cookies.set('token',response.data.result.token)
            //保存用户信息到本地会话
            localStorage.setItem('user',response.data.result.user.uName)

            setTimeout(() => {
              _this.$router.push({
                path: '/'
              });
            }, 1500);

          } else {
            _this.errormsg(response.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // adminLogin(){
    //   this.$index.push({ path: '/LoginAdmin' });
    // },
    // register(){
    //    this.dialog_regs = true
    // }
  }
}
</script>

<style>
/*登录form*/
#login{
  /* width: 100%; */
  /* margin: 0 auto; */
  /*position:relative;*/
  /*background-color:black;*/
  position:absolute;
  width:100%;
  margin: 0 auto;
  height:100%;
  /* top:0px;left:0px; */
  overflow: hidden;
}
/*登录背景*/
#login_img{
  position:absolute;
  width: 100%;
}
#login_img img{
  width: 100%;
}

/*输入框*/
#login_main{
   width: 22%;
   margin:10% 5% 10% 40%;
   border:1px solid #C0CCDA;
   opacity:0.8;
   border-radius:10px;
   box-shadow:inset 0 0 1px 1px #C0CCDA;
   position:absolute;
   background-color:#F9FAFC;
}
#login_main_top{
  height: 5%;
  /*background-color:green;*/
  text-align: center;
}
#login_main_center{
   margin: 1% 20% 0% 20%;
   /*background-color:green;*/
}
/* #login_main_center input{
   margin: 0 25% 1% 7%;
   width: 93%;
} */

/*登录按钮*/
#login_button_user{
  /* margin-left: 7%; */
}
#login_button_user button{
  width: 100%;
}
/*管理员登录按钮*/
#login_button_admin{
  margin-left:60px;
  margin-right:15px;
}
/*注册按钮*/
/*#reset_button{
  margin-left:220px;
}*/

/*
 * Footer
 */
#login_footer {
  margin:43% 5% 5% 38%;
  color: #000;
  text-align: center;
  position: absolute;
  background-color: #f9f9f9;
  border-top: 1px solid #e5e5e5;
}

  </style>



// WEBPACK FOOTER //
// src/pages/Login.vue